import {Injectable} from '@angular/core';
import {DatePipe} from '@angular/common';


@Injectable({
  providedIn: 'root'
})
export class UtilityService {

  loanStatus: any[];
  printDetailsMap: any;
  productCode: any[];
  gender: any[];
  sortOrder: any[];
  loanPurchCd: any[];
  paymentPln: any[];
  racer: any[];
  inrateType: any[];
  dwellingType: any[];
  ethnicity: any[];
  transactionStatus: any[];
  transactionStatusType: any[];
  actionCode: any[];
  actionTypeCode: any[];
  tranDesignator: any[];
  transactionDesignatorTypeCode: any[];
  tranType: any[];
  portfolioTypeCode: any[];
  queryLoanStatus: any[];
  schdPaymentStatus: any[];
  detailSchdPaymentStatus: any[];
  queryLoanPaymentPln: any[];
  loanStatusCode: any[];
  dailyReports: any[];
  monthlyReports: any[];
  adhocReports: any[];

  constructor( ) {

    this.loanStatus = [];
    this.loanStatus.push({label: 'All', value: 'A'});
    this.loanStatus.push({label: 'Incomplete', value: 'I'});
    this.loanStatus.push({label: 'Eligible For Transmission', value: 'C'});
    this.loanStatus.push({label: 'Saved With Errors', value: 'E'});
    this.loanStatus.push({label: 'Transmitted', value: 'T'});
    this.loanStatus.push({label: 'Pending Certification', value: 'PC'});
    this.loanStatus.push({label: 'Pending Purchase', value: 'PP'});
    this.loanStatus.push({label: 'Pending Contract Funds', value: 'PF'});
    this.loanStatus.push({label: 'Pending Purchase with Errors', value: 'PE'});
    this.loanStatus.push({label: 'Deleted', value: 'D'});
    this.loanStatus.push({label: 'Purchased', value: 'P'});

    this.queryLoanStatus = [];
    this.queryLoanStatus.push({label: 'ALL', value: 'ALL'});
    this.queryLoanStatus.push({label: '0-Active', value: '0'});
    this.queryLoanStatus.push({label: '11-Refer for FCL: Death', value: '11'});
    this.queryLoanStatus.push({label: '12-Refer for FCL: Non-Occupancy', value: '12'});
    this.queryLoanStatus.push({label: '13-Refer for FCL: T&I', value: '13'});
    this.queryLoanStatus.push({label: '14-Refer for FCL: Other', value: '14'});
    this.queryLoanStatus.push({label: '15-Bankruptcy', value: '15'});
    this.queryLoanStatus.push({label: '20-Referred for Deed-In-Lieu', value: '20'});
    this.queryLoanStatus.push({label: '30-Referred for Foreclosure', value: '30'});
    this.queryLoanStatus.push({label: '50-Default: Non-Occupancy', value: '50'});
    this.queryLoanStatus.push({label: '51-Default: T&I', value: '51'});
    this.queryLoanStatus.push({label: '52-Default: Other', value: '52'});
    this.queryLoanStatus.push({label: '55-Called Due: Death', value: '55'});
    this.queryLoanStatus.push({label: '56-Called Due: Non-Occupancy', value: '56'});
    this.queryLoanStatus.push({label: '57-Called Due: T&I', value: '57'});
    this.queryLoanStatus.push({label: '58-Called Due: Other', value: '58'});
    this.queryLoanStatus.push({label: '70-Liquid/Held for Sale', value: '70'});
    this.queryLoanStatus.push({label: '71-Liquid/3rd Party Sale/Short Payoff', value: '71'});
    this.queryLoanStatus.push({label: '72-Liquid/Pending Conveyance', value: '72'});
    this.queryLoanStatus.push({label: '60-Payoff', value: '60'});

    this.schdPaymentStatus = [];
    this.schdPaymentStatus.push({ label: 'ALL', value: 'ALL' });
    this.schdPaymentStatus.push({ label: '00-Standard Scheduled Payment', value: '0' });
    this.schdPaymentStatus.push({ label: '01-Suspend Scheduled Payment', value: '1' });
    this.schdPaymentStatus.push({ label: '02-Resume Scheduled Payment', value: '2' });




    this.detailSchdPaymentStatus = [];
    this.detailSchdPaymentStatus.push({ label: 'Default', value: 'ALL' });
    this.detailSchdPaymentStatus.push({ label: 'Suspend', value: '1' });
    this.detailSchdPaymentStatus.push({ label: 'Resume', value: '2' });
    this.detailSchdPaymentStatus.push({ label: 'Default', value: '0' });


    this.productCode = [];
    this.productCode.push({label: 'ALL', value: ''});
    this.productCode.push({label: 'HECM', value: '1'});
    this.productCode.push({label: 'HKM', value: '2'});

    this.sortOrder = [];
    this.sortOrder.push({label: 'Fannie Mae Loan Number', value: '0'});
    this.sortOrder.push({label: 'Lender Loan Number', value: '1'});
    this.sortOrder.push({label: 'Contract Number', value: '2'});
    this.sortOrder.push({label: 'Seller Number', value: '3'});
    this.sortOrder.push({label: 'Servicer Number', value: '4'});
    this.sortOrder.push({label: 'Purchase Date', value: '5'});

    this.gender = [];
    this.gender.push({label: 'Not Given', value: '3'});
    this.gender.push({label: 'Male', value: '1'});
    this.gender.push({label: 'Female', value: '2'});
    this.gender.push({label: 'No Co-Borrower', value: '4'});

    this.loanPurchCd = [];

    this.loanPurchCd.push({label: '01-New', value: '01'});
    this.loanPurchCd.push({label: '02- REFI (FNMA Owned)', value: '02'});
    this.loanPurchCd.push({label: '03-H4P (HECM for Purchase)', value: '03'});
    this.loanPurchCd.push({label: '04- S2R (REFI non FNMA Owned)', value: '04'});
    this.loanPurchCd.push({label: '05- REPUR (Repurchase)', value: '05'});
    this.loanPurchCd.push({label: '06 -REPUR-REFI (FNMA Owned)', value: '06'});
    this.loanPurchCd.push({label: '07 -REPUR-H4P (HECM for Purchase)', value: '07'});
    this.loanPurchCd.push({label: '08 -REPUR-S2R (REFI non FNMA Owned)', value: '08'});
    this.loanPurchCd.push({label: '09 -REPUR (Other)', value: '09'});

    this.paymentPln = [];
    this.paymentPln.push({label: 'ALL', value: 'All'});
    this.paymentPln.push({label: 'Term', value: '1'});
    this.paymentPln.push({label: 'Tenure', value: '2'});
    this.paymentPln.push({label: 'Modified Term', value: '3'});
    this.paymentPln.push({label: 'Modified Tenure', value: '4'});
    this.paymentPln.push({label: 'LOC', value: '5'});

    this.queryLoanPaymentPln = [];
    this.queryLoanPaymentPln.push({label: 'ALL', value: 'All'});
    this.queryLoanPaymentPln.push({label: 'Term', value: '1'});
    this.queryLoanPaymentPln.push({label: 'Tenure', value: '2'});
    this.queryLoanPaymentPln.push({label: 'Modified Term', value: '3'});
    this.queryLoanPaymentPln.push({label: 'Modified Tenure', value: '4'});
    this.queryLoanPaymentPln.push({label: 'Line of Credit ', value: '5'});

    this.racer = [];
    this.racer.push({label: 'American Indian or Alaskan Native', value: '1'});
    this.racer.push({label: 'Asian', value: '2'});
    this.racer.push({label: 'Black or African American', value: '3'});
    this.racer.push({label: 'Native Hawaiian or Pacific Islander', value: '4'});
    this.racer.push({label: 'White', value: '5'});
    this.racer.push({label: 'Not Provided', value: '6'});
    this.racer.push({label: '', value: '7'});
    this.racer.push({label: 'No Co-Borrower', value: '8'});
    this.racer.push({label: '', value: ''});


    this.ethnicity = [];

    this.ethnicity.push({label: 'Hispanic or Latino', value: '1'});
    this.ethnicity.push({label: 'Not Hispanic or Latino', value: '2'});
    this.ethnicity.push({label: 'Not Provided', value: '3'});
    this.ethnicity.push({label: '', value: ''});
    this.ethnicity.push({label: 'No Co-Borrower', value: '5'});

    this.dwellingType = [];
    this.dwellingType.push({label: 'Single Family', value: 'S'});
    this.dwellingType.push({label: 'Condo', value: 'C'});
    this.dwellingType.push({label: 'PUD', value: 'P'});
    this.dwellingType.push({label: '', value: ''});

    this.inrateType = [];
    this.inrateType.push({label: 'Fixed', value: '1'});
    this.inrateType.push({label: 'Adjustable', value: '2'});
    this.inrateType.push({label: 'Adjustable', value: '3'});

    this.transactionStatus = [];
    this.transactionStatus.push({ label: 'ALL', value: 'ALL' });
    this.transactionStatus.push({ label: 'Pending', value: '1' });
    this.transactionStatus.push({ label: 'Approved', value: '2' });
    this.transactionStatus.push({ label: 'Applied', value: '3' });
    this.transactionStatus.push({ label: 'Deleted', value: '5' });

    this.transactionStatusType = Array.from(this.transactionStatus);
    this.transactionStatusType.push({ label: 'Rejected', value: '4' });
    this.transactionStatusType.push({ label: 'Pending', value: '6' });//label & description is same as PENDING for UI display purposes
    this.transactionStatusType.push({ label: 'To Be Processed', value: '7' });
    this.transactionStatusType.push({ label: 'Server Failure', value: '99' });

    this.actionCode = [];
    this.actionCode.push({ label: 'ALL', value: 'ALL' });
    this.actionCode.push({ label: '80-Part Prepymt/Reduce UPB Only', value: '80' });
    this.actionCode.push({ label: '81-Part Prepymt/Increase Net LOC', value: '81' });

    this.actionCode.push({ label: '82-Part Prepymt/Inc Repair Set-Aside', value: '82' });
    this.actionCode.push({ label: '83-Part Prepymt/Increase Taxes&Ins', value: '83' });
    this.actionCode.push({ label: '84-Part Prepymt/Inc 1st Yr Prop Chgs', value: '84' });

    this.actionCode.push({ label: '90-Unschd Pymt/Taxes', value: '90' });
    this.actionCode.push({ label: '91-Unschd Pymt/Insurance', value: '91' });
    this.actionCode.push({ label: '92-Unschd Pymt/Inspection', value: '92' });
    this.actionCode.push({ label: '93-Unschd Pymt/Appraisal', value: '93' });
    this.actionCode.push({ label: '94-Unschd Pymt/Property Reservation', value: '94' });
    this.actionCode.push({ label: '41-Unschd Pymt/Repairs Not Final', value: '41' });
    this.actionCode.push({ label: '42-Unschd Pymt/1st Yr Prop Chg Not Final', value: '42' });
    this.actionCode.push({ label: '43-Unschd Pymt/Taxes & Insurance', value: '43' });
    this.actionCode.push({ label: '44-Unschd Pymt/Net Line of Credit', value: '44' });

    this.actionCode.push({ label: '45-Unschd Pymt/Repairs Final', value: '45' });
    this.actionCode.push({ label: '46-Unschd Pymt/1st Yr Prop Chg Final', value: '46' });
    this.actionCode.push({ label: '47-Unschd Pymt/Appraisal Fee', value: '47' });
    this.actionCode.push({ label: '48-Unschd Pymt/LOC Tax Payment', value: '48' });
    this.actionCode.push({ label: '49-Unschd Pymt/Payment Plan Change', value: '49' });
    this.actionCode.push({ label: '0-Active', value: '0' });

    this.actionCode.push({ label: '01-Suspend Scheduled Payment', value: '1' });
    this.actionCode.push({ label: '02-Resume Scheduled Payment', value: '2' });
    this.actionCode.push({ label: '11-Refer for FCL: Death', value: '11' });
    this.actionCode.push({ label: '12-Refer for FCL: Non-Occupancy', value: '12' });
    this.actionCode.push({ label: '13-Refer for FCL: T&I', value: '13' });
    this.actionCode.push({ label: '14-Refer for FCL: Other', value: '14' });
    this.actionCode.push({ label: '15-Bankruptcy', value: '15' });

    this.actionCode.push({ label: '20-Referred for Deed-In-Lieu', value: '20' });
    this.actionCode.push({ label: '50-Default: Non-Occupancy', value: '50' });
    this.actionCode.push({ label: '51-Default: T&I', value: '51' });
    this.actionCode.push({ label: '52-Default: Other', value: '52' });
    this.actionCode.push({ label: '53-Default: Valid_Repayment_Plan', value: '53' });

    this.actionCode.push({ label: '55-Called Due: Death', value: '55' });
    this.actionCode.push({ label: '56-Called Due: Non-Occupancy', value: '56' });
    this.actionCode.push({ label: '57-Called Due: T&I', value: '57' });
    this.actionCode.push({ label: '58-Called Due: Other', value: '58' });
    this.actionCode.push({ label: '70-Liquid/Held for Sale', value: '70' });
    this.actionCode.push({ label: '71-Liquid/3rd Party Sale/Short Payoff', value: '71' });
    this.actionCode.push({ label: '72-Liquid/Pending Conveyance', value: '72' });
    this.actionCode.push({ label: '31-Payoff/Death', value: '31' });
    this.actionCode.push({ label: '32-Payoff/Borrower_moved', value: '32' });

    this.actionCode.push({ label: '33-Payoff/Borrower_Paid_Off', value: '33' });
    this.actionCode.push({ label: '34-Payoff/Other_Reason', value: '34' });
    this.actionCode.push({ label: '35-Payoff/Unknown_Reason', value: '35' });
    this.actionCode.push({ label: '65-Repurchased', value: '65' });
    this.actionCode.push({ label: '66-Refinanced', value: '66' });
    this.actionCode.push({ label: '124-SERVICING TRANSFER', value: '124' });
    this.actionCode.push({ label: '125-Payment Change', value: '125' });

    this.actionTypeCode = [];

    this.actionTypeCode.push({ label: '0-LOAN ACTIVE', value: '0' });
    this.actionTypeCode.push({ label: '1-SUSPEND SCHEDULED PYMT', value: '1' });
    this.actionTypeCode.push({ label: '2-RESUME SCHEDULED PYMT', value: '2' });
    this.actionTypeCode.push({ label: '11-Referred FOR FCL DEATH', value: '11' });
    this.actionTypeCode.push({ label: '12-Referred FOR FCL NON OCPY', value: '12' });
    this.actionTypeCode.push({ label: '13-Referred FOR FCL TI', value: '13' });
    this.actionTypeCode.push({ label: '14-Referred FOR FCL OTHER', value: '14' });
    this.actionTypeCode.push({ label: '15-BANKRUPTCY', value: '15' });

    this.actionTypeCode.push({ label: '20-DEED IN LIEU', value: '20' });
    this.actionTypeCode.push({ label: '21-AT RISK EXTENSION', value: '21' });
    this.actionTypeCode.push({ label: '22-NON BORROWING SPOUSE', value: '22' });
    this.actionTypeCode.push({ label: '30-FORECLOSURE', value: '30' });
    this.actionTypeCode.push({ label: '31-PAYOFF DUE TO DEATH', value: '31' });
    this.actionTypeCode.push({ label: '32-PAYOFF BORROWER MOVED', value: '32' });
    this.actionTypeCode.push({ label: '33-PAYOFF BORROWER PAYOFF', value: '33' });
    this.actionTypeCode.push({ label: '34-PAYOFF OTHER', value: '34' });
    this.actionTypeCode.push({ label: '35-PAYOFF UNKNOWN REASON', value: '35' });

    this.actionTypeCode.push({ label: '41-UNSCHED RS NOT FINAL', value: '41' });
    this.actionTypeCode.push({ label: '42-UNSCHED FYP NOT FINAL', value: '42' });
    this.actionTypeCode.push({ label: '43-UNSCHED TI SETASIDE', value: '43' });
    this.actionTypeCode.push({ label: '44-UNSCHED NET LINE CREDIT', value: '44' });
    this.actionTypeCode.push({ label: '45-UNSCHED RS FINAL', value: '45' });
    this.actionTypeCode.push({ label: '46-UNSCHED FYP FINAL', value: '46' });
    this.actionTypeCode.push({ label: '47-UNSCHED APPR PAYOFF', value: '47' });
    this.actionTypeCode.push({ label: '48-UNSCHED LOC TAX PMT', value: '48' });
    this.actionTypeCode.push({ label: '49-UNSCHED PMT PLAN CHANGE', value: '49' });

    this.actionTypeCode.push({ label: '50-DEFAULT NON OCPY', value: '50' });
    this.actionTypeCode.push({ label: '51-DEFAULT TI', value: '51' });
    this.actionTypeCode.push({ label: '52-DEFAULT OTHER', value: '52' });
    this.actionTypeCode.push({ label: '55-CALLED DUE DEATH', value: '55' });
    this.actionTypeCode.push({ label: '53-DEFAULT REPYMT PLAN', value: '53' });
    this.actionTypeCode.push({ label: '56-CALLED DUE NON OCPY', value: '56' });
    this.actionTypeCode.push({ label: '57-CALLED DUE TI', value: '57' });
    this.actionTypeCode.push({ label: '58-CALLED DUE OTHER', value: '58' });

    this.actionTypeCode.push({ label: '60-PAYOFF', value: '60' });
    this.actionTypeCode.push({ label: '61-SHORT PAYOFF', value: '61' });
    this.actionTypeCode.push({ label: '65-REPURCHASED', value: '65' });
    this.actionTypeCode.push({ label: '66-REFINANCED', value: '66' });
    this.actionTypeCode.push({ label: '70-LIQUIDATED HELD FOR SALE', value: '70' });
    this.actionTypeCode.push({ label: '71-LIQUIDATED THIRD PARTY SALE', value: '71' });
    this.actionTypeCode.push({ label: '72-LIQUIDATED CONVEYANCE', value: '72' });

    this.actionTypeCode.push({ label: '80-PARTIAL PREPAYMENT', value: '80' });
    this.actionTypeCode.push({ label: '81-PARTIAL PREPAYMENT INCR NLC', value: '81' });
    this.actionTypeCode.push({ label: '82-PARTIAL PREPAYMENT INCR RS', value: '82' });
    this.actionTypeCode.push({ label: '83-PARTIAL PREPAYMENT INCR TI', value: '83' });
    this.actionTypeCode.push({ label: '84-PARTIAL PREPAYMENT INCR FYP', value: '84' });

    this.actionTypeCode.push({ label: '90-ACTION UNSCHED TAXES', value: '90' });
    this.actionTypeCode.push({ label: '91-ACTION UNSCHED INSURANCE', value: '91' });
    this.actionTypeCode.push({ label: '92-ACTION UNSCHED INSPECTION', value: '92' });
    this.actionTypeCode.push({ label: '93-ACTION UNSCHED APPRAISAL', value: '93' });
    this.actionTypeCode.push({ label: '94-UNSCHED PROP PRESERVATION', value: '94' });

    this.actionTypeCode.push({ label: 'ACRU MIP BB', value: '100' });
    this.actionTypeCode.push({ label: 'ACRU INTEREST BB', value: '102' });
    this.actionTypeCode.push({ label: '103-RECORD SCHEDULED PYMT', value: '103' });
    this.actionTypeCode.push({ label: 'ACRU MIP SCHEDULED PYMT', value: '104' });
    this.actionTypeCode.push({ label: 'ACRU INT SCHEDULED PYMT', value: '106' });
    this.actionTypeCode.push({ label: 'ACRU MIP UNSCHED', value: '107' });
    this.actionTypeCode.push({ label: 'ACRU INTEREST UNSCHED', value: '109' });

    this.actionTypeCode.push({ label: 'ACRU SERVICE FEE', value: '110' });
    this.actionTypeCode.push({ label: 'ACRU MIP PARTIAL PREPAYMENT', value: '112' });
    this.actionTypeCode.push({ label: 'ACRU INT PARTIAL PREPAYMENT', value: '114' });
    this.actionTypeCode.push({ label: 'FIRST YEAR PROP ROLLOVER', value: '115' });
    this.actionTypeCode.push({ label: 'PRINCIPAL LIMIT GROWTH', value: '117' });
    this.actionTypeCode.push({ label: 'LCR GROWTH', value: '118' });
    this.actionTypeCode.push({ label: 'DISBURSE UPB ADJ', value: '119' });

    this.actionTypeCode.push({ label: 'DISBURSE MIP ADJ', value: '120' });
    this.actionTypeCode.push({ label: 'CURRENT INT ADJ', value: '121' });
    this.actionTypeCode.push({ label: 'PRIOR PERIOD INT ADJ', value: '122' });
    this.actionTypeCode.push({ label: 'DISBURSE SERVICE FEE ADJ', value: '123' });
    this.actionTypeCode.push({ label: 'SERVICING TRANSFER', value: '124' });
    this.actionTypeCode.push({ label: 'PAYMENT CHANGE', value: '125' });
    this.actionTypeCode.push({ label: 'ACRU MIP ULB', value: '126' });
    this.actionTypeCode.push({ label: 'ACRU INT ULB', value: '127' });
    this.actionTypeCode.push({ label: 'ACRU RECORD SCHEDULED TI', value: '128' });
    this.actionTypeCode.push({ label: 'RECALC SERVICE FEE SETASIDE', value: '129' });

    this.actionTypeCode.push({ label: 'PAYOFF TOLERANCE', value: '130' });
    this.actionTypeCode.push({ label: 'REPAIR SETASIDE TO LOCR', value: '131' });
    this.actionTypeCode.push({ label: 'FY PROP TO LOCR', value: '132' });
    this.actionTypeCode.push({ label: 'ACRU MIP ULB UNSCHED', value: '133' });
    this.actionTypeCode.push({ label: 'ACRU INT ULB UNSCHED', value: '134' });
    this.actionTypeCode.push({ label: 'ACRU MIP ULB PP', value: '137' });
    this.actionTypeCode.push({ label: 'ACRU INT ULB PP', value: '138' });

    this.actionTypeCode.push({ label: 'ACRU INT UNSCHED PRIOR PURCHASE', value: '151' });
    this.actionTypeCode.push({ label: 'ACRU INT PREPAYMENT PRIOR PURCHASE', value: '152' });

    this.tranDesignator = [];
    this.tranDesignator.push({ label: 'ALL', value: 'ALL' });
    this.tranDesignator.push({ label: 'Unscheduled', value: '2' });
    this.tranDesignator.push({ label: 'LSM', value: '3' });
    this.tranDesignator.push({ label: 'PartialPrePayment', value: '1' });
    this.tranDesignator.push({ label: 'Payoff', value: '6' });
    this.tranDesignator.push({ label: 'PayChange', value: '4' });
    this.tranDesignator.push({ label: 'Scheduled Pymt', value: '7' });

    this.transactionDesignatorTypeCode = [];
    this.transactionDesignatorTypeCode.push({ label: 'System Generated', value: '0' });
    this.transactionDesignatorTypeCode.push({ label: 'Partial Prepayment', value: '1' });
    this.transactionDesignatorTypeCode.push({ label: 'Unscheduled Payment', value: '2' });
    this.transactionDesignatorTypeCode.push({ label: 'Loan Status Maintenance', value: '3' });
    this.transactionDesignatorTypeCode.push({ label: 'Payment Change', value: '4' });
    this.transactionDesignatorTypeCode.push({ label: 'Service Transfer', value: '5' });
    this.transactionDesignatorTypeCode.push({ label: 'Payoff Transaction', value: '6' });
    this.transactionDesignatorTypeCode.push({ label: 'Scheduled Payment', value: '7' });
    this.transactionDesignatorTypeCode.push({ label: 'Purchase Adjustment', value: '8' });
    this.transactionDesignatorTypeCode.push({ label: 'Default Loan Status Maintenance', value: '81' });
    this.transactionDesignatorTypeCode.push({ label: 'Trial Balance', value: '99' });

    this.tranType = [];
    this.tranType.push({ label: 'ALL', value: 'ALL' });
    this.tranType.push({ label: 'Current', value: '1' });
    this.tranType.push({ label: 'Adjustment', value: '2' });
    this.tranType.push({ label: 'Reversal', value: '3' });

    this.portfolioTypeCode = [];
    this.portfolioTypeCode.push({label: 'ALL', value: '1'});
    this.portfolioTypeCode.push({label: 'All HECM', value: '2'});
    this.portfolioTypeCode.push({label: 'All HKM', value: '3'});

    this.loanStatusCode = [];
    this.loanStatusCode.push({ label: 'ACTIVE', value: '0' });
    this.loanStatusCode.push({ label: 'INACTIVE', value: '1' });
  }


  /* Method to convert Milliseconds to Date format */
  public convertMillisecToDate(inputDate: any | string) {

    const  date = new Date(inputDate);

    const dd = String(date.getUTCDate()).padStart(2, '0');
    const mm = String(date.getUTCMonth() + 1).padStart(2, '0'); //January is 0!
    const yyyy = date.getUTCFullYear();

    return mm + '/' + dd + '/' + yyyy;

  }

  public milliSecToMMYYYY(inputDate: any | string) {

    const  date = new Date(inputDate);
    const mm = String(date.getUTCMonth() + 1).padStart(2, '0'); //January is 0!
    const yyyy = date.getUTCFullYear();

    return mm + '/' + yyyy;

  }



  public convertDateToMillisec(inputDate: any | string) {

    const  date : Date = new Date(inputDate);
    return date.getTime();

  }

  /* Method to convert Milliseconds to 12-hour Date/Time format */
  public convertMillisecToDateTime(inputDate: any | string) {
    return new DatePipe('en-US').transform(inputDate, 'MM/dd/yyyy hh:mm a');
  }

  public convertMillisecToDateYearOnly(inputDate: any | string)
  {
    const  date = new Date(inputDate);

    const yyyy = date.getUTCFullYear();

    return yyyy;
  }

  /* Method to convert Milliseconds to Date/Time format/Seconds */
  public convertMillisecToDateTimeSec(inputDate: any | string) {
    const date = new Date(inputDate);
    const hours = date.getHours();
    const ampm = hours >= 12 ? 'pm' : 'am';
    return [date.getMonth() + 1, date.getDate(), date.getFullYear()].join('/') + ' ' + [date.getHours(), date.getMinutes(), date.getSeconds()].join(':') + ' ' + ampm;
  }


  public getFirstDayOfMonth(inputDate: any | string) {
    const date = new Date(inputDate);
    const firstDay = new Date(date.getFullYear(), date.getMonth(), 1);


    const dd = String(firstDay.getUTCDate()).padStart(2, '0');
    const mm = String(firstDay.getUTCMonth() + 1).padStart(2, '0'); //January is 0!
    const yyyy = firstDay.getUTCFullYear();

    return mm + '/' + dd + '/' + yyyy;

  }

  /** validate Illegal char validation  and return or false*/
  isContainIllegalChar(stringInput: string) {
    const format = /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
    return format.test(stringInput);
  }

  /** method to replace string */
  public stringReplace(src: string, val1: string, val2: string): string {
    src = src.replace('{0}', val1);
    src = src.replace('{1}', val2);
    return src;
  }

  public printViewData(printDetailsMap)
  {
    this.printDetailsMap = printDetailsMap;
  }

  public getPrintViewData()
  {
    return this.printDetailsMap;
  }

  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;

  }

  public getProfileCode(profideCodeDesc: string) {
    if (profideCodeDesc == null) {
      return -1;
    } else if (profideCodeDesc === 'Partial') {
      return 4;
    }
    else if (profideCodeDesc === 'ALL') {
      return 1;
    }
    else if (profideCodeDesc === 'All HECM') {
      return 2;
    }
    else if (profideCodeDesc === 'All HKM') {
      return 3;
    }

    return -1;
  }

  public get9DigitSeller(isExternal: boolean): number {

    if (isExternal) {
      const selrList = JSON.parse(sessionStorage.getItem('sellerNumbersArr'));
      const srvrList = JSON.parse(sessionStorage.getItem('authServicerNumbersArr'));
      if (srvrList != null) {
        for (let i = 0; i < selrList.length; i++)
        {
          if (srvrList.includes(selrList[i])) {
            return selrList[i];
          }
        }
      }

      if (selrList != null && selrList.length > 0) {
        return selrList[0];
      }
    }
    return null;
  }

  public isUserAuthorizedForServicerNumber(servNumber: any) {
    let flag = false;
    if (sessionStorage.getItem('isExternal') === 'true') {
      if (sessionStorage.getItem('authServicerNumbersArr') != null
        && sessionStorage.getItem('authServicerNumbersArr').includes(servNumber)) {
        flag = true;
      }
    } else {
      flag = true;
    }
    return flag;
  }

  public isUserAuthorizedForSellerNumber(sellerNumber: string) {
    let flag = false;
    if (sessionStorage.getItem('isExternal') === 'true') {
      if (sessionStorage.getItem('sellerNumbersArr') != null
        && sessionStorage.getItem('sellerNumbersArr').includes(sellerNumber)) {
        flag = true;
      }
    } else {
      flag = true;
    }
    return flag;
  }

  public paymenetPlanById(id: string) {
    return this.queryLoanPaymentPln.filter((d) => d.value === id)[0];
  }
  public getLastDayOfMonth(inputDate: any | string) {
    const date = new Date(inputDate);
    const lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    const dd = String(lastDay.getUTCDate()).padStart(2, '0');
    const mm = String(lastDay.getUTCMonth() + 1).padStart(2, '0'); //January is 0!
    const yyyy = lastDay.getUTCFullYear();

    return mm + '/' + dd + '/' + yyyy;

  }

  public isNotBlank(s : string): boolean {
    return s !== null && s !== undefined && s.trim().length > 0;
  }
  public isBlank(s : string): boolean {
    return !this.isNotBlank(s);
  }

  public isLong(filed: string) {
    return /^[-]?[0-9]+$/.test(filed);
  }

  public isValidDate(dateString: string) {
    // First check for the pattern
    if (!/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(dateString)) {
      return false;
    }

    // Parse the date parts to integers
    const parts = dateString.split('/');
    const day = parseInt(parts[1], 10);
    const month = parseInt(parts[0], 10);
    const year = parseInt(parts[2], 10);

    const monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

    // Adjust for leap years
    if (year % 400 === 0 || (year % 100 !== 0 && year % 4 === 0)) {
      monthLength[1] = 29;
    }
    // Check the range of the day
    const validDate =  day > 0 && day <= monthLength[month - 1];

    const currentTime = new Date();
    let validYear = true;
    // Check the ranges of month and year
    if (year > currentTime.getFullYear()) {
      validYear =  false;
    } else if (year < 1600) {
      validYear =  false;
    }
    return validDate && validYear && (month > 0 && month < 13);
  }

  public containsIllegalCharacter(str: string) {
    if ( this.isBlank(str) || str === 'null' ) {
      return false;
    }
    const illegalString = '<>="\'%;)(&+\\?~|^*[]-{}$';
    for (let i = 0; i < str.length; i++) {
      if (illegalString.includes(str.charAt(i))) {
        return true;
      }
    }
    return false;
  }

  // checks if the field variable is a number, returns true if it is not a number and false if it is a number
  // this does not work with empty strings, and all space strings
  // string must have at least 1 char for this check to work (i.e., '  s  2' -> 's2')
  public isNotNumber(value: any) {
    // remove all spaces from the value
    return isNaN(+value);
  }

  // removes all spaces from the variable, checks if null/undefined, return true if empty and false if not empty
  public isEmpty(value: any) {
    let empty = false;

    if (value === null || value === undefined ||
      value.toString().replace(/\s/g, '').length === 0)
    {
      empty = true;
    }

    return empty;
  }

  // remove all spaces from the variable and return the real length
  public getActualLength(value: any) {
    return value.replace(/\s/g, '').length;
  }

  public getReportNameByRPT(rpt: string) {
    const rptMap = {

      // Accounting Monthly
      RPT_01:'Disbursement_Reconciliation_Detail_Report',
      RPT_02:'Disbursement_Reconciliation_Summary_Report',
      RPT_03:'Net_Principal_Limit_Report',
      RPT_04:'LOC_Reserve_Report',
      RPT_05:'Loan_Adjustment_Detailed_Listing_Report',
      RPT_07:'Portfolio_Loan_Balance_Summary_Listing_Report',
      RPT_08:'Reverse_Mortgage_Rate_Changes_Report',
      RPT_09:'UPB_Monthly_Reconciliation_Report',
      RPT_10:'MIP_Monthly_Reconciliation_Report',
      RPT_11:'Monthly_Reconciliation_File_Service_Fee_Report',
      RPT_12:'Servicing_Transfer_Detail_Report_by_Lender',
      RPT_14B:'Yield Extract Report',
      RPT_15:'Outstanding_Maximum_Claim_Amount_Report',
      RPT_16:'HECM_Fixed_Rate_Monthly_Interest_Reconciliation_File_Report',
      RPT_17:'HECM_ARMS_Monthly_Interest_Reconciliation_File_Report',
      RPT_18:'HKM_Monthly_Interest_Reconciliation_File_Report',
      RPT_19:'Servicer_Portfolio_Summary_Report',
      RPT_20:'First_Year_Property_Charge_Rollover_Report',
      RPT_21:'Early_Warning_Report',
      RPT_23:'Scheduled_and_UnScheduled_Payments_Report',
      RPT_32:'Monthly_Portfolio_Activity_Summary_Report',
      RPT_33:'Liquidation_Reconciliation_Report',
      RPT_35:'Data Extract Download Report',
      RPT_36:'Servicing_Statistics_Report',
      RPT_37:'Adjusted_Property_Value_Report',
      RPT_38:'Interest_Extract_Report',
      RPT_39:'Scheduled_Payment_Rejection_Report',
      RPT_40:'Monthly_Adjustments_Report',

      // Accounting daily
      RPT_22:'ACH_Servicing_Transactions_Report',
      RPT_24:'Manual_Load_Summary_Report',
      RPT_25:'Detailed_Liquidation_Report',
      RPT_26:'Servicing_Transaction_Upload_Report',
      RPT_27:'Servicer_Transfer_Data_Log_Report',
      RPT_28:'Reconciliation_Exception_Report',
      RPT_29:'Loan_Balance_Compare_Report',
      RPT_30:'Servicers_Trial_Balance_Status_Report',
      RPT_31:'Trial_Balance_Upload_Status_Report',
      RPT_RSS_01:'Draft_Notification_Detail_Report',
      RPT_RSS_02:'Daily_Reconciliation_Report',
      RPT_RSS_03:'Reconciliation_MIP_and_Service_Fee_Report',
      RPT_RSS_04:'Reconciliation_Scheduled_Payments_Report',

      // Accounting adhoc
      RPT_06:'Portfolio_Loan_Balance_Detailed_Listing_Report',
      RPT_13:'Servicing_Disbursement_Verification_Report',
      RPT_24A:'Manual_Load_Summary_Adhoc_Report',
      RPT_24a:'Manual_Load_Summary_Adhoc_Report',
      RPT_25A:'Detailed_Liquidation_Adhoc_Report',
      RPT_30A:'Servicers_Trial_Balance_Status_Report',

      // Admin reports
      RPT_124:'Loan_Modification_Report',
      RPT_125:'Loan_Modification_By_LoanNo_Report',
      RPT_111:'Contract_List_by_SellerNumber_Report',
      RPT_112:'Contract_Details_by_ContractNumber_Report',
      RPT_113:'Seller_Servicer_Info_Report',
      RPT_114:'Seller_Servicer_Info_by_Name_Report',
      RPT_115:'Index_Rate_Report'

    };
    return rptMap[rpt];
  }

}
